// extracted by mini-css-extract-plugin
export default {"helpLink":"ZendeskHelp-module__helpLink__xj__m","popularArticles":"ZendeskHelp-module__popularArticles__f83At","promotedArticles":"ZendeskHelp-module__promotedArticles___I2Mo"};